import { render, staticRenderFns } from "./dietPlan.vue?vue&type=template&id=4475fcf6&scoped=true&"
import script from "./dietPlan.vue?vue&type=script&lang=js&"
export * from "./dietPlan.vue?vue&type=script&lang=js&"
import style0 from "./dietPlan.vue?vue&type=style&index=0&id=4475fcf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4475fcf6",
  null
  
)

component.options.__file = "dietPlan.vue"
export default component.exports